<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    관리자목록
                    <el-button class="title_btn" @click="openPopup" type="primary">연락처 등록</el-button>
                </div>
                <div class="list-content">
                    <admin-list-component :adminType="`admin`"></admin-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
        <admin-management-modal></admin-management-modal>
    </div>
</template>

<script>
import AdminListComponent from "@/components/admin/AdminListComponent";
import AdminManagementModal from "@/components/modal/AdminManagementModal";
export default {
    name: 'Admin',
    mixins: [],
    components: {AdminListComponent,AdminManagementModal},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        openPopup(idx) {
            this.$modal.show('admin-management-modal',{adminType:'adminCreate'})
        },
    },
    watch: {},
}
</script>
